import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_highlight_text_value = _resolveComponent("highlight-text-value");
  const _component_FlexRow = _resolveComponent("FlexRow");
  const _component_WrapWithSectionItem = _resolveComponent("WrapWithSectionItem");
  return _openBlock(), _createBlock(_component_WrapWithSectionItem, {
    selected: $props.selected,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', {
      [$props.item_id_key]: $props.item_id,
      [$props.item_name_key]: $props.item_name
    })),
    onDeselect: _cache[1] || (_cache[1] = $event => _ctx.$emit('deselect', {
      [$props.item_id_key]: $props.item_id,
      [$props.item_name_key]: $props.item_name
    })),
    onSelectOnly: _cache[2] || (_cache[2] = $event => _ctx.$emit('selectOnly', {
      [$props.item_id_key]: $props.item_id,
      [$props.item_name_key]: $props.item_name
    }))
  }, {
    default: _withCtx(() => [_createVNode(_component_FlexRow, {
      gap: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_highlight_text_value, {
        class: "name",
        value: $props.item_name,
        query: $props.query,
        main: ""
      }, null, 8, ["value", "query"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["selected"]);
}